<template>
  <div>
    <GridInput
        v-if="contentType === 'grid'"
        :attribute="gridAttribute"
        :disabled="readonly"
        @onChange="onGridChange"
    />

    <StructuredListInput
        v-else-if="contentType === 'structured_list'"
        :attribute="listAttribute"
        :disabled="readonly"
        @onChange="onListChange"
    />

    <div v-else-if="contentType === 'text'" class="col-md-12 mb-6">
      <label class="form-label">Conteúdo</label>
      <textarea
          class="form-control form-control-solid"
          rows="6"
          :disabled="readonly"
          :value="textValue"
          @input="onTextChange($event.target.value)"
      ></textarea>
    </div>

    <PrescriptionDrugs
        v-else-if="contentType === 'medication'"
        :medical-record="medicalRecord"
        :prescription="prescription"
        :drug-admins="drugAdmins"
        :readonly="readonly"
        :regulatory-plan="regulatoryPlan"
        :regulatory-types="regulatoryTypes"
        :presc-types="prescTypes"
        @regulatory-changed="$emit('regulatory-changed')"
    />
  </div>
</template>

<script>
import GridInput from "../shared/GridInput.vue";
import StructuredListInput from "../shared/StructuredListInput.vue";
import PrescriptionDrugs from "../tab/PrescriptionDrugs.vue";

export default {
  name: "PrescriptionContentEditor",
  components: {GridInput, StructuredListInput, PrescriptionDrugs},
  emits: ['update:payload', 'regulatory-changed'],
  props: {
    prescription: {
      type: Object,
      required: true,
    },
    medicalRecord: Object,
    drugAdmins: Array,
    prescriptionProtocols: Array,
    readonly: Boolean,
    regulatoryPlan: Object,
    prescTypes: {
      type: Array,
      default: () => [],
    },
    regulatoryTypes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    contentType() {
      return this.prescription?.content_type ?? 'medication';
    },
    modelOptions() {
      const fromPrescription = this.prescription?.prescription_model?.options;
      if (fromPrescription && Object.keys(fromPrescription).length > 0) {
        return fromPrescription;
      }

      const protocolId = this.prescription?.id_presc_prot;
      if (protocolId && this.prescriptionProtocols?.length) {
        const protocol = this.prescriptionProtocols.find((model) => model.id_presc_prot == protocolId);
        if (protocol?.options) {
          return protocol.options;
        }
      }

      return {};
    },
    gridAttribute() {
      return {
        label: this.prescription?.presc_name ?? 'Grade',
        options: this.modelOptions,
        text: JSON.stringify(this.prescription?.presc_payload ?? {}),
      };
    },
    listAttribute() {
      const items = this.prescription?.presc_payload?.items ?? [];
      return {
        label: this.prescription?.presc_name ?? 'Lista',
        options: this.modelOptions,
        text: JSON.stringify(items),
      };
    },
    textValue() {
      return this.prescription?.presc_payload?.text ?? '';
    },
  },
  methods: {
    onGridChange(attribute) {
      let payload = {};
      try {
        payload = JSON.parse(attribute.text ?? '{}');
      } catch (_) {
        payload = {};
      }
      this.$emit('update:payload', payload);
    },
    onListChange(attribute) {
      let items = [];
      try {
        items = JSON.parse(attribute.text ?? '[]');
      } catch (_) {
        items = [];
      }
      this.$emit('update:payload', {items});
    },
    onTextChange(value) {
      this.$emit('update:payload', {text: value});
    },
  },
};
</script>
